export enum FeatureFlags {
  ACTIVITY_DASHBOARD = "activityDashboard",
  SELLER_PRIORITY = "sellerPriority",
  COLLAPSED_TABS = "collapsedTabs",
  EST_STOCK_DISPLAY = "estStockDisplay",
  PRICE_ALERTS = "priceAlerts",
  FOREVER_LAUNCH = "foreverLaunch",
  AUTO_LAUNCH = "autoLaunch",
  WEEKLY_ENFORCEMENT_REPORT = "weeklyEnforcementReport",
}
export interface FeatureFlag {
  name: string;
  displayName: string;
  active: boolean;
}

// A flag in this map may only be enabled while its mapped prerequisite flag
// is active. Enforced authoritatively by the `configsOnWrite` Firestore
// trigger (firebase/functions/triggers/featureFlagPolicy.js); mirrored here
// so the client can block/disable the toggle before it round-trips.
export const FLAG_PREREQUISITES: Partial<Record<FeatureFlags, FeatureFlags>> =
  {
    [FeatureFlags.AUTO_LAUNCH]: FeatureFlags.FOREVER_LAUNCH,
  };
